// extracted by mini-css-extract-plugin
export default {"container":"SupplierAdPopUp_container__5QMks","checkbox":"SupplierAdPopUp_checkbox__BoJDX"};